export enum ShipmentDirections {
  "DOMESTIC" = "DOMESTIC",
  "IMPORT" = "IMPORT",
  "EXPORT" = "EXPORT",
}
